import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Selora',
    description:
        'Selora is the studio of Jayson Castle — an ongoing record of image, object, motion and sound, made when thought moves faster than structure.',
    placeholder: '',
    url: getOrigin()
}

export const studio = {
    brand: 'Selora',
    artist: 'Jayson Castle',
    role: 'Visual Artist / Creator',
    initials: 'AK',
    yearFrom: '2015',
    yearTo: '2026',
    phone: '(44) 7700 900 482',
    phoneRaw: '+447700900482',
    email: 'hey@selora.design',
    address: [
        'STUDIO 204',
        '22–24 Great Eastern Street',
        'Shoreditch',
        'London EC2A 3NW',
        'United Kingdom'
    ],
    copyright: '© 2026 Selora by Jayson Castle. All work, all rights.'
} as const
